import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import classnames from "classnames";
export var FlowVerticalView = function FlowVerticalView(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var getClassName = getClassNameFactory(FlowVerticalView.displayName);
  return /*#__PURE__*/React.createElement("ol", {
    className: classnames(getClassName(), className)
  }, children);
};
FlowVerticalView.displayName = "FlowVerticalView";